/**
 * ScrollContainer's configuration warning, `get_configuration_warnings()`
 * (scroll_container.cpp:768-786): `found != 1` sortable children, so zero warns
 * too. The five internal children it skips are never serialised.
 */
import { ruleRegistry } from '../../../../linter/RuleRegistry.js';
import { isTypeUnknowable } from '../../../../linter/parentType.js';
import { descendsFromClass } from '../../../../godot/classdb/classBaseTypes.js';
import { boolSlotValue } from '../../../../godot/variant/variantBool.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../../linter/ruleArms.js';
const arms = {
    notSingleChild: groundedArm('scrollcontainer-not-single-child', { kind: 'configuration-warning' }),
};
/**
 * `as_sortable_control(child, VISIBLE)` is non-null, per container.cpp:143-155:
 * a Control, not top-level, with its own `visible` set. An ancestor's
 * visibility does not count.
 */
function isSortableControl(child) {
    if (!descendsFromClass(child.type, 'Control'))
        return false;
    const props = child.rawProperties;
    if (boolSlotValue(props.top_level) === true)
        return false;
    if (boolSlotValue(props.visible) === false)
        return false;
    return true;
}
function checkScrollContainer(context) {
    const { node } = context;
    const children = node.children ?? [];
    // Instance-opaque linting (GLOSSARY.md): an `instance=` or typeless child's
    // class lives in a sub-scene the linter never opens, so the count is unknown.
    if (children.some(isTypeUnknowable))
        return [];
    const sortableCount = children.filter(isSortableControl).length;
    if (sortableCount === 1)
        return [];
    return [
        armDiagnostic(arms.notSingleChild, node, `ScrollContainer '${node.name}' has ${sortableCount} sortable child controls; it is intended to work with exactly one. Use a container as the single child (VBoxContainer, HBoxContainer, …), or a single Control with its custom minimum size set manually.`),
    ];
}
const scrollContainerRule = {
    meta: {
        name: 'valid-scrollcontainer-single-child',
        description: 'Flags a ScrollContainer that does not have exactly one sortable Control child',
        category: 'validation',
        applicableNodeTypes: ['ScrollContainer'],
        emits: armEmits(arms),
    },
    check: checkScrollContainer,
};
ruleRegistry.register(scrollContainerRule);
//# sourceMappingURL=linter.js.map